import { API_URL } from '../../../app-config/constants';
import { get } from '../request';

const BASE_URL = `${API_URL}/email-events`;

getMailEventsFiltered.operation = 'READ';
getMailEventsFiltered.idFrom = 'ARGS';
export function getMailEventsFiltered(params, companyId) {
    const url = companyId ? `${BASE_URL}/${companyId}` : BASE_URL;
    return get(url, { getData: params });
}
